"use strict";

exports.parseJSONImpl = function (str) {
  return JSON.parse(str);
};



//////////////////
// WEBPACK FOOTER
// ./output/Data.Foreign.JSON/foreign.js
// module id = 586
// module chunks = 0